document.addEventListener('DOMContentLoaded', () => {
    const focusSearchInputIn = (container) => {
        if (!container) return;
        const input = container.querySelector('input[type="search"], .ofra-search__input, .search__input');
        if (input) {
            setTimeout(() => {
                try { input.focus(); } catch (e) {}
            }, 100);
        }
    };

    document.querySelectorAll('.open-search').forEach((button) => {
        button.addEventListener('click', function () {
            const searchSection = document.querySelector('.ofra-search__section');
            const searchOverlay = document.querySelector('.ofra-search__overlay');

            if (!searchSection || !searchOverlay) return;

            searchSection.style.transform = 'translateY(0)';
            searchOverlay.style.display = 'block';
            document.body.style.overflow = 'hidden';
            const handler = () => {
                focusSearchInputIn(searchSection);
                searchSection.removeEventListener('transitionend', handler);
            };
            searchSection.addEventListener('transitionend', handler);
            setTimeout(() => focusSearchInputIn(searchSection), 250);
        });
    });
    const topIcon = document.querySelector('.ofra-search__top .ofra-search__icon');
    if (topIcon) {
        topIcon.addEventListener('click', function () {
            const section = document.querySelector('.ofra-search__section');
            const overlay = document.querySelector('.ofra-search__overlay');
            const input = document.querySelector('.ofra-search__input');
            if (section) section.style.transform = 'translateY(-200%)';
            if (overlay) overlay.style.display = 'none';
            if (input) input.value = '';
            document.body.style.overflow = '';
        });
    }

    const closeBtn = document.querySelector('.ofra-search__close-button');
    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            const section = document.querySelector('.ofra-search__section');
            const overlay = document.querySelector('.ofra-search__overlay');
            const input = document.querySelector('.ofra-search__input');
            if (section) section.style.transform = 'translateY(-200%)';
            if (overlay) overlay.style.display = 'none';
            if (input) input.value = '';
            document.body.style.overflow = '';
        });
    }

    // CLOSE when clicking outside (overlay)
    const overlay = document.querySelector('.ofra-search__overlay');
    if (overlay) {
        overlay.addEventListener('click', function (e) {
            if (e.target === this) {
                const section = document.querySelector('.ofra-search__section');
                const input = document.querySelector('.ofra-search__input');
                if (section) section.style.transform = 'translateY(-200%)';
                this.style.display = 'none';
                document.body.style.overflow = '';
                if (input) input.value = '';
            }
        });
    }

    //    Targets: button.ofra-button-search should focus the inline input in .ofra-search__scrolled
    document.querySelectorAll('.ofra-button-search').forEach((btn) => {
        btn.addEventListener('click', () => {
            const scrolledContainer = btn.closest('.ofra-navbar__icons--scrolled-search');
            if (scrolledContainer) {
                const inlineSearch = scrolledContainer.querySelector('.ofra-search__scrolled');
                setTimeout(() => focusSearchInputIn(inlineSearch || scrolledContainer), 100);
            }
        });
    });

    document.querySelectorAll('.header__search details').forEach((det) => {
        det.addEventListener('toggle', () => {
            if (det.open) {
                const content = det.querySelector('.search-modal, .search-modal__content') || det;
                setTimeout(() => focusSearchInputIn(content), 120);
            }
        });
    });
});